<div class="subtitle-1 font-weight-bold mt-3" cvLocalizedText langSection="SSO" langKey="Sso">SSO</div>
<ng-container *ngIf="settings != null">
    <div class="d-flex flex-row justify-content-between">
        <div class="form-check d-flex">
            <input class="form-check-input" type="checkbox" id="enableSSO"
                   [(ngModel)]="settings.EnableSSO" [disabled]="!editing ||settings.CompanyID == 0"
                   (ngModelChange)="toggleSSO()" />
            <label class="form-check-label pl-1" for="enableSSO">{{ localization.get("Enable_Sso") ?? "Enable SSO" }}</label>
        </div>

        <div [hidden]="!hasSAMLDL()">
            <div class="col">
                <div ngbDropdown class="d-inline-block ml-auto" style="margin-bottom: 0 !important;">
                    <button type="button" class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>
                        {{ localization.get("Download") ?? "Download" }}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                        <button ngbDropdownItem [hidden]="!hasMetaDL()" (click)="download()">{{ localization.get("Metadata") ?? "Metadata" }}</button>
                        <button ngbDropdownItem [hidden]="!hasSigningCertDL()" (click)="download(1)">{{ localization.get("Signing_Cert") ?? "Signing Cert" }}</button>
                        <button ngbDropdownItem [hidden]="!hasEncryptionCertDL()" (click)="download(2)">{{ localization.get("Encryption_Cert") ?? "Encryption Cert" }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div [hidden]="!settings.EnableSSO">
        <!-- Dropdown Options and downloads-->
        <div class="d-flex mt-3">
            <div class="d-flex flex-column mr-3 col-4 pl-0" style="width: 150px">
                <div class="font-size-12">
                    <span>{{ localization.get("Sso_Identity_Provider") ?? "SSO Identity Provider" }}</span>
                </div>
                <select class="form-control" [disabled]="!editing" [(ngModel)]="settings.SSOProvider"
                        (ngModelChange)="updateProvider()">
                    <option *ngFor="let provider of providers" value="{{ provider }}">{{ localization.get(provider) ?? provider }}</option>
                </select>
            </div>
            <div class="d-flex flex-column mr-3" style="width: 150px">
                <div class="font-size-12">
                    <span>{{ localization.get("Sso_Protocol") ?? "SSO Protocol" }}</span>
                </div>
                <select class="form-control" [(ngModel)]="settings.SSOProtocol"
                        [disabled]="!editing || protocols.length < 2" (ngModelChange)="updateProtocol()">
                    <option *ngFor="let protocol of protocols" value="{{ protocol }}">
                        {{ localization?.get(protocol) ?? protocol }}
                    </option>
                </select>
            </div>
        </div>
        <ng-container *ngIf="(settings.SSOProtocol == 'SAML' && encryptions.length > 1) || (settings.SSOProtocol == 'SAML' && transportAlgorithms.length > 1 && settings.SSOEncryptionMethod != 'Unencrypted')">
            <div class="d-flex mt-3">
                <div class="d-flex flex-column mr-3 col-4 pl-0" style="width: 150px"
                     *ngIf="settings.SSOProtocol == 'SAML' && encryptions.length > 1">
                    <div class="font-size-12">
                        <span [matTooltip]="localization.get('Encryption_Alg_T') ?? 'Which encryption should be used for requests'">{{ localization.get("Encryption_Alg") ?? "Encryption Algorithm" }}</span>
                    </div>
                    <!-- Currently not supported -->
                    <select class="form-control" [disabled]="!editing || true" [(ngModel)]="settings.SSOEncryptionMethod" (ngModelChange)="onUpdate()">
                        <option *ngFor="let encryption of encryptions" value="{{ encryption }}">
                            {{ localization?.get(encryption) ?? encryption }}
                        </option>
                    </select>
                </div>
                <div class="d-flex flex-column mr-3" style="width: 150px"
                     *ngIf="settings.SSOProtocol == 'SAML' && transportAlgorithms.length > 1 && settings.SSOEncryptionMethod != 'Unencrypted'">
                    <div class="font-size-12">
                        <span [matTooltip]="localization.get('Transport_Alg_T') ?? 'Which transport algorithm should be used to send requests'">{{ localization.get("Transport_Alg") ?? "Key Transport Algorithm" }}</span>
                    </div>
                    <!-- Currently not supported -->
                    <select class="form-control" [disabled]="!editing || true" [(ngModel)]="settings.SSOTransportAlgorithm" (ngModelChange)="onUpdate()">
                        <option *ngFor="let transport of transportAlgorithms" value="{{ transport }}">
                            {{ localization?.get(transport) ?? transport }}
                        </option>
                    </select>
                </div>
                <div class="d-flex flex-column mr-3" style="width: 150px" *ngIf="hasSamlBindings()">
                    <div class="font-size-12">
                        <span [matTooltip]="localization.get('Protocol_Binding_T') ?? 'Which protocol to send authn requests with'">{{ localization.get('Protocol_Binding') ?? 'Protocol Binding'}}</span>
                    </div>
                    <select class="form-control" [disabled]="!editing" [(ngModel)]="settings.SSOSamlBinding" (ngModelChange)="onUpdate()">
                        <option *ngFor="let binding of samlBindings" value="{{ binding }}">
                            {{ localization?.get(binding) ?? binding }}
                        </option>
                    </select>
                </div>
            </div>
        </ng-container>

        <!-- Checkbox options -->
        <div class="d-flex flex-row mt-3" *ngIf="hasWantSignedAssertion() || hasSignAuthnRequests()">
            <div class="form-check d-flex mr-3 col-4" *ngIf="hasWantSignedAssertion()">
                <input class="form-check-input" type="checkbox" id="signedAssertions" [disabled]="!editing"
                       [(ngModel)]="settings.SSOSignedAssertions" (ngModelChange)="onUpdate()" />
                <label class="form-check-label pl-1" for="signedAssertions" [matTooltip]="localization.get('Signed_Assertion_T') ?? 'Assertions from IdP must have valid signature'">{{ localization.get("Signed_Assertion") ?? "Signed assertions" }}</label>
            </div>
            <div class="form-check d-flex mr-3" *ngIf="hasSignAuthnRequests()">
                <input class="form-check-input" type="checkbox" id="signAuthn" [disabled]="!editing"
                       [(ngModel)]="settings.SSOSignAuthnRequests" (ngModelChange)="onUpdate()" />
                <label class="form-check-label pl-1" for="signAuthn" [matTooltip]="localization.get('Sign_Authn_T') ?? 'Sign authn request sent to IdP'">{{ localization.get("Sign_Authn") ?? "Sign authn requests" }}</label>
            </div>
        </div>
        <div class="d-flex flex-row mt-3" *ngIf="hasRollSigningKeys() || hasRollEncryptionKeys()">
            <div class="form-check d-flex mr-3 col-4" *ngIf="hasRollSigningKeys()">
                <input class="form-check-input" type="checkbox" id="rollSigning" [disabled]="!editing"
                       [(ngModel)]="settings.SSORollSigning" (ngModelChange)="onUpdate()" />
                <label class="form-check-label pl-1" for="rollSigning" [matTooltip]="localization.get('Roll_Signing_T') ?? 'Generate new signing keys'">{{ localization.get("Roll_Signing") ?? "Roll signing keys" }}</label>
            </div>
            <div class="form-check d-flex mr-3" *ngIf="hasRollEncryptionKeys()">
                <input class="form-check-input" type="checkbox" id="rollEncryption" [disabled]="!editing"
                       [(ngModel)]="settings.SSORollEncryption" (ngModelChange)="onUpdate()" />
                <label class="form-check-label pl-1" for="rollEncryption" [matTooltip]="localization.get('Roll_Encryption_T') ?? 'Generate new encryption keys'">{{ localization.get("Roll_Encryption") ?? "Roll encryption keys" }}</label>
            </div>
        </div>

        <!-- Text Options -->
        <div class="font-size-12 mt-3">
            <span [matTooltip]="localization.get('Identity_Provider_Url_T') ?? 'Url to send request'">{{ localization.get("Identity_Provider_Url") ?? "Identity Provider URL" }}</span>
            <span class="color-redRyder" title="Required">*</span>
        </div>
        <input id="ssoIdentityProvider" class="form-control" type="text" [disabled]="!editing"
               placeholder="https://" [(ngModel)]="settings.SSOIdentityProviderURL" (ngModelChange)="onUpdate()" />

        <div class="font-size-12 mt-3">
            <span [matTooltip]="localization.get('Client_Id_T') ?? 'Client ID'">{{ localization.get("Client_Id") ?? "Client ID" }}</span>
            <span class="color-redRyder" title="Required">*</span>
        </div>
        <input class="form-control" type="text" [disabled]="!editing" [(ngModel)]="settings.SSOClientID" (ngModelChange)="onUpdate()" />

        <div [hidden]="!hasClientSecret()">
            <div class="font-size-12 mt-3">
                <span [matTooltip]="localization.get('Client_Secret_T') ?? 'Client secret'">{{ localization.get("Client_Secret") ?? "Client Secret" }}</span>
                <span class="color-redRyder" title="Required">*</span>
            </div>
            <input class="form-control" type="text" [disabled]="!editing" [(ngModel)]="settings.SSOClientSecret" (ngModelChange)="onUpdate()" />
        </div>

        <div [hidden]="!hasIdPID()">
            <div class="font-size-12 mt-3">
                <span [matTooltip]="localization.get('IdPId_T') ?? 'Unique identifier used to identify the IdP'">{{ localization.get("Idp_Id") ?? "IdP ID" }}</span>
                <span class="color-redRyder" title="Required">*</span>
            </div>
            <input class="form-control" type="text" [disabled]="!editing" [(ngModel)]="settings.SSOIdPId" (ngModelChange)="onUpdate()" />
        </div>

        <div [hidden]="!hasX509Certificate()">
            <div class="font-size-12 mt-3">
                <span [matTooltip]="localization.get('X509_T') ?? 'Certificate used to verify identity providers signature'">{{ localization.get("X509") ?? "X.509 Certificate" }}</span>
                <span class="color-redRyder" title="Required">*</span>
            </div>
            <textarea class="form-control" style="height: 200px" [disabled]="!editing"
                      [(ngModel)]="settings.SSOX509Certificate" (ngModelChange)="onUpdate()">
        </textarea>
        </div>
    </div>
</ng-container>
